import { render, staticRenderFns } from "./videoChaternew.vue?vue&type=template&id=143bfbc8&scoped=true"
import script from "./videoChaternew.vue?vue&type=script&lang=js"
export * from "./videoChaternew.vue?vue&type=script&lang=js"
import style0 from "./videoChaternew.vue?vue&type=style&index=0&id=143bfbc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143bfbc8",
  null
  
)

export default component.exports